import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getUseIsMaintenanceQueryOptions } from "../../../maintenance-check-point/queries/useIsMaintenanceQuery";
import { TrashScheduleModel } from "../../models/TrashScheduleModel";
import {
  getTrashSchedule,
  TrashScheduleQueryParams,
} from "../api/getTrashSchedule";

export const getTrashScheduleQueryKey = (
  addressPoint: TrashScheduleQueryParams
) => [addressPoint.id];

export const useTrashScheduleQuery = (
  addressPoint: TrashScheduleQueryParams,
  options: { enabled?: boolean } = {}
) => {
  const client = useQueryClient();
  return useQuery<TrashScheduleModel>(
    getTrashScheduleQueryKey(addressPoint),
    () => {
      client.prefetchQuery(...getUseIsMaintenanceQueryOptions);
      return getTrashSchedule(addressPoint);
    },
    {
      ...options,
    }
  );
};
